// ======================================================================
// FILE: src/modules/wms/WMSLayout.jsx
// MODULE: Work Management System (WMS)
// PURPOSE:
//   Main layout wrapper for WMS module
//   - Includes WMS Sidebar
//   - Handles content spacing
//   - Follows ERP module architecture
// ======================================================================

import React, { useState } from "react";

import WMSSidebar
from "./layout/WMSSidebar";

export default function WMSLayout({
  children,
}) {

  const [
    sidebarExpanded,
    setSidebarExpanded
  ] = useState(true);

  return (

    <div
      style={{
        minHeight: "100vh",
        background: "#f3f4f6",
      }}
    >

      {/* SIDEBAR */}

      <WMSSidebar
        onToggle={(expanded) =>
          setSidebarExpanded(
            expanded
          )
        }
      />

      {/* MAIN CONTENT */}

      <main
        style={{
          marginLeft:
            sidebarExpanded
              ? 260
              : 64,

          transition:
            "margin-left 0.22s ease",

          padding: 20,
        }}
      >
        {children}
      </main>

    </div>
  );
}